module.exports = __webpack_public_path__ + "static/media/baby.f1d1e750.jpg";